import addAnswer from "./addanswer";

export default function addAddButton(divID){
            
    let dropdown        = document.getElementById(divID.dataset.id);
    let dropdownItems   = dropdown.lastElementChild.querySelectorAll('.input-group-addon');

    if (dropdownItems.length == 1) {

        let removeAnswerSpan    = document.createElement('span');
        let removeAnswerA       = document.createElement('a');

        removeAnswerSpan.classList.add('input-group-addon');
        removeAnswerSpan.style.padding = '0';
        removeAnswerA.classList.add('btn','btn-primary', 'positive', 'addAnswer','addButton');
        removeAnswerA.innerText = '+';
        removeAnswerA.dataset.id = divID.dataset.id;
        removeAnswerSpan.append(removeAnswerA);
        dropdown.lastElementChild.querySelector('.input-group').append(removeAnswerSpan);
        
        removeAnswerA.addEventListener('click', function(){

            addAnswer(this);

        });

    }
    
}